const baseClass = "js-hero",
  attributeNames = {
    ACTIVE_INDEX: "data-active-index",
  },
  eventNames = {
    SCROLL_END: "scrollend",
    MOUSE_DOWN: "mousedown",
    TOUCH_START: "touchstart",
  },
  interval = {
    SLIDER: 7000,
  },
  selectors = {
    BASE: `.${baseClass}`,
    ITEM: `.${baseClass}-item`,
    ITEMS_CONTAINER: `.${baseClass}-items`,
    INDICATOR: `.${baseClass}-indicator`,
  };

let index = 0;

/**
 * @this Hero
 */
function checkAutoplay() {
  let shouldAutoplay = document.body.scrollTop === 0;

  if (!shouldAutoplay) {
    stopAutoPlay.call(this);
    return;
  }

  if (this.intervalId) {
    return;
  }

  startAutoPlay.call(this);
}

/**
 * @this Hero
 */
function updateActiveIndex() {
  const containerLeft = this.itemsContainer.scrollLeft;

  let closestIndex = 0;
  let minDistance = Math.abs(this.items[0].offsetLeft - containerLeft);

  this.items.forEach((item, i) => {
    const distance = Math.abs(item.offsetLeft - containerLeft);
    if (distance < minDistance) {
      minDistance = distance;
      closestIndex = i;
    }
  });

  this.indicator.setAttribute(attributeNames.ACTIVE_INDEX, closestIndex);
}

/**
 * @this Hero
 */
function startAutoPlay() {
  this.intervalId = setInterval(() => {
    index = (index + 1) % this.items.length;

    this.items[index].scrollIntoView({
      behavior: "smooth",
    });
  }, interval.SLIDER);
}

/**
 * @this Hero
 */
function stopAutoPlay() {
  if (this.intervalId === null) {
    return;
  }

  clearInterval(this.intervalId);
  this.intervalId = null;
}

/**
 * @this Hero
 * @param {HTMLElement} baseElement
 */
function bindEvents(baseElement) {
  document.body.addEventListener(
    eventNames.SCROLL_END,
    checkAutoplay.bind(this),
  );
  this.itemsContainer.addEventListener(
    eventNames.SCROLL_END,
    updateActiveIndex.bind(this),
  );

  baseElement.addEventListener(eventNames.MOUSE_DOWN, stopAutoPlay.bind(this));
  baseElement.addEventListener(eventNames.TOUCH_START, stopAutoPlay.bind(this));

  let shouldAutoplay = document.body.scrollTop === 0;

  if (shouldAutoplay) {
    startAutoPlay.call(this);
  }
}

class Hero {
  /**
   * Creates an instance of Menu.
   *
   * @param {HTMLElement} [baseElement=document.querySelector(selectors.BASE)]
   * @memberof Menu
   */
  constructor(baseElement = document.querySelector(selectors.BASE)) {
    if (baseElement === null) {
      return;
    }

    this.intervalId = null;

    this.baseElement = baseElement;
    this.indicator = document.querySelector(selectors.INDICATOR);
    this.items = Array.from(baseElement.querySelectorAll(selectors.ITEM));
    this.itemsContainer = document.querySelector(selectors.ITEMS_CONTAINER);

    bindEvents.call(this, baseElement);
  }

  /**
   *
   * @type {HTMLElement}
   * @memberof Hero
   */
  get baseElement() {
    return this._baseElement;
  }
  set baseElement(value) {
    this._baseElement = value;
  }

  /**
   * @memberof Hero
   */
  get indicator() {
    return this._indicator;
  }
  set indicator(value) {
    this._indicator = value;
  }

  /**
   * @memberof Hero
   */
  get items() {
    return this._items;
  }
  set items(value) {
    this._items = value;
  }

  /**
   * @memberof Hero
   */
  get itemsContainer() {
    return this._itemsContainer;
  }
  set itemsContainer(value) {
    this._itemsContainer = value;
  }

  /**
   * @memberof Hero
   */
  get intervalId() {
    return this._intervalId;
  }
  set intervalId(value) {
    this._intervalId = value;
  }
}

function init() {
  new Hero();
}

init();

export default Hero;
